import type { IPayoutTransactionMinimal } from "../../../../types/models/payout-transaction.modals.types";
import { usePostHttp } from "../../http.hook";

export interface IPostResponse {
	payout: IPayoutTransactionMinimal;
}

interface IBody {
	message: string;
}

export function usePayoutRejectAdminHttp() {
	return usePostHttp<IBody, IPostResponse>({
		path: "/admin/payouts/transactions/:id/reject",
	});
}
